<template lang="pug">
b-modal#modal-heatmap-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p
      | 以下のタグをヒートマップ計測対象Webページのbody内に設置してください。タグ設置方法は
      a.text-primary(href="https://docs.google.com/presentation/d/1KpAYhUqPNecSY-hVYmDiLVE6omAjmDcQspgZnOYY988/edit?usp=sharing", target="_blank") こちら
      | をご参照ください。
  .row
    textarea.form-control(rows=5)
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.heatmap.url}}"></script>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
